// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-content-details {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(75% - 15px);
  background-color: var(--color-blue-cream);
  padding: 25px;
  border-radius: 8px;
  border: 1px solid var(--color-border-gray);
}

.cart-content-details .cart-content-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cart-content-details .cart-content-details-header h2, .cart-content-details h2 {
  font-family: "Lexend Deca", sans-serif;
  color: var(--brown-dark);
  font-size: 28px;
}

.cart-content-details .cart-content-details-header a {
  color: var( --color-text-dark);
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  text-decoration: none;
}

.cart-list {
  margin-top: 25px;
}

.cart-item {
  width: 100%;
  height: auto;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 15px;
  margin-bottom: 25px;
  background-color: var(--color-white-main);
  border: 1px solid var(--color-border-gray);
  border-radius: 8px;
}

.product-image {
  width: 20%;
}

.product-image img {
  display: block;
  max-width: 100%;
  height: auto;
}

.product-info {
  width: 30%;
}

.product-info span {
  display: block;
}

.product-info .category {
  color: var(--color-text-blue);
  font-family: "Lexend Deca", sans-serif;
  font-weight: 300;
  font-size: 14px;
}

.product-info .name {
  color: var(--color-text-dark);
  font-family: "Poppins", sans-serif;
  font-weight: bolder;
  margin: 2px 0px;
  font-size: 16px;
}

.product-info .weight {
  color: var(--color-text-gray);
  font-family: "Lexend Deca", sans-serif;
  font-weight: 300;
  font-size: 14px;
}

.product-price {
  width: 25%;
}

.product-price .price {
  color: var(--color-text-blue);
  font-family: "Poppins", sans-serif;
  font-weight: bolder;
  font-size: 14px;
}

.product-amount {
  width: 20%;
  display: flex;
}

.product-amount input {
  width: 40px;
  margin: 0px 5px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid var(--color-border-gray);
  font-weight: bolder;
  outline: none;
  font-size: 12px;
  font-family: "Lexend Deca", sans-serif;
}

input[type="number"]::-webkit-inner-spin-button {
  appearance: none;
  margin: 0px;
}

.product-amount input:focus {
  border: 1px solid var(--color-blue-aux);
}

.product-amount .change-quantity {
  width: 20px;
  height: 20px;
  font-size: 10px;
  border-radius: 100%;
  background-color: var(--color-blue-circle);
  color: var(--color-text-dark);
  font-weight: bolder;
  border: none;
  outline: none;
}

.product-option {
  width: 5%;
}

.product-option .delete {
  background-color: transparent;
  color: var(--color-text-blue);
  border: none;
  outline: none;
  font-size: 20px;
}

@media only screen and (max-width: 600px) {
  .cart-content-details {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 0px);
    margin-bottom: 25px;
  }
  .cart-item {
    flex-wrap: wrap;
    gap: 8px;
  }
  .product-image {
    width: 100%;
  }
  .product-info {
    width: 100%;
  }
  .product-price {
    width: 100%;
  }
  .product-amount {
    width: 50%;
  }
  .product-image img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: auto;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .cart-content-details {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 0px);
    margin-bottom: 25px;
  }
  .cart-item {
    flex-wrap: wrap;
    gap: 0px;
  }
  .product-image {
    width: 20%;
    padding: 0px 16px 0px 0px !important;
  }
  .product-info {
    width: 35%;
  }
  .product-price {
    width: 20%;
  }
  .product-amount {
    width: 20%;
  }

  .product-option {
    width: 5%;
  }
  .product-image img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/order-details/OrderDetails.css"],"names":[],"mappings":"AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":["@import url(\"../../App.css\");\n\n.cart-content-details {\n  flex: 0 0 calc(75% - 15px);\n  background-color: var(--color-blue-cream);\n  padding: 25px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border-gray);\n}\n\n.cart-content-details .cart-content-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cart-content-details .cart-content-details-header h2, .cart-content-details h2 {\n  font-family: \"Lexend Deca\", sans-serif;\n  color: var(--brown-dark);\n  font-size: 28px;\n}\n\n.cart-content-details .cart-content-details-header a {\n  color: var( --color-text-dark);\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n  text-decoration: none;\n}\n\n.cart-list {\n  margin-top: 25px;\n}\n\n.cart-item {\n  width: 100%;\n  height: auto;\n  padding: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 15px;\n  margin-bottom: 25px;\n  background-color: var(--color-white-main);\n  border: 1px solid var(--color-border-gray);\n  border-radius: 8px;\n}\n\n.product-image {\n  width: 20%;\n}\n\n.product-image img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n.product-info {\n  width: 30%;\n}\n\n.product-info span {\n  display: block;\n}\n\n.product-info .category {\n  color: var(--color-text-blue);\n  font-family: \"Lexend Deca\", sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n}\n\n.product-info .name {\n  color: var(--color-text-dark);\n  font-family: \"Poppins\", sans-serif;\n  font-weight: bolder;\n  margin: 2px 0px;\n  font-size: 16px;\n}\n\n.product-info .weight {\n  color: var(--color-text-gray);\n  font-family: \"Lexend Deca\", sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n}\n\n.product-price {\n  width: 25%;\n}\n\n.product-price .price {\n  color: var(--color-text-blue);\n  font-family: \"Poppins\", sans-serif;\n  font-weight: bolder;\n  font-size: 14px;\n}\n\n.product-amount {\n  width: 20%;\n  display: flex;\n}\n\n.product-amount input {\n  width: 40px;\n  margin: 0px 5px;\n  text-align: center;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-gray);\n  font-weight: bolder;\n  outline: none;\n  font-size: 12px;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  appearance: none;\n  margin: 0px;\n}\n\n.product-amount input:focus {\n  border: 1px solid var(--color-blue-aux);\n}\n\n.product-amount .change-quantity {\n  width: 20px;\n  height: 20px;\n  font-size: 10px;\n  border-radius: 100%;\n  background-color: var(--color-blue-circle);\n  color: var(--color-text-dark);\n  font-weight: bolder;\n  border: none;\n  outline: none;\n}\n\n.product-option {\n  width: 5%;\n}\n\n.product-option .delete {\n  background-color: transparent;\n  color: var(--color-text-blue);\n  border: none;\n  outline: none;\n  font-size: 20px;\n}\n\n@media only screen and (max-width: 600px) {\n  .cart-content-details {\n    flex: 0 0 calc(100% - 0px);\n    margin-bottom: 25px;\n  }\n  .cart-item {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  .product-image {\n    width: 100%;\n  }\n  .product-info {\n    width: 100%;\n  }\n  .product-price {\n    width: 100%;\n  }\n  .product-amount {\n    width: 50%;\n  }\n  .product-image img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    margin: auto;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  .cart-content-details {\n    flex: 0 0 calc(100% - 0px);\n    margin-bottom: 25px;\n  }\n  .cart-item {\n    flex-wrap: wrap;\n    gap: 0px;\n  }\n  .product-image {\n    width: 20%;\n    padding: 0px 16px 0px 0px !important;\n  }\n  .product-info {\n    width: 35%;\n  }\n  .product-price {\n    width: 20%;\n  }\n  .product-amount {\n    width: 20%;\n  }\n\n  .product-option {\n    width: 5%;\n  }\n  .product-image img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
